export { EntityTypeTile, type EntityTypeTileProps } from './EntityTypeTile';
